import { render, staticRenderFns } from "./EventoSesion.vue?vue&type=template&id=0c70c5de&"
import script from "./EventoSesion.vue?vue&type=script&lang=js&"
export * from "./EventoSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports